/**
 * Site-wide mobile layout tokens — Figma 402px artboard, responsive 320–425px.
 */
export const MOBILE_MIN = 320
export const MOBILE_MAX = 425
export const MOBILE_MQ = `@media (max-width: ${MOBILE_MAX}px)`

/** Tablet portrait/landscape — between phone (≤425) and desktop (≥1200) */
export const TABLET_MIN = 600
export const TABLET_MAX = 1199
export const TABLET_MQ = `@media (min-width: ${TABLET_MIN}px) and (max-width: ${TABLET_MAX}px)`

export const mobilePaddingX = { xs: '20px', sm: 3, md: 5, lg: 10, xl: '200px' }

export const mobileHeaderHeight = 72

export const mobileSectionPy = { xs: '80px', md: 10, lg: 12 }

/** Intermediate section vertical padding for tablet/laptop */
export const tabletSectionPy = { xs: '80px', md: 10, lg: 12 }

export const mobileSectionTitleSx = {
  fontSize: { xs: 28, sm: 40, md: 56, lg: 48 },
  lineHeight: 'normal',
  fontWeight: 400,
  color: '#111',
}

export const mobileSectionLabelSx = {
  fontSize: { xs: 14, md: 18, lg: 22 },
  lineHeight: 'normal',
  fontWeight: 400,
  color: '#111',
}

export const mobileBodyTextSx = {
  fontSize: { xs: 16, sm: 22, md: 30, lg: 30 },
  lineHeight: 'normal',
  fontWeight: 400,
  color: '#111',
}

export const mobileTitleToContentGap = { xs: '32px', md: '48px', lg: '80px' }

/** Intermediate title-to-content gap for tablet/laptop */
export const tabletTitleToContentGap = { xs: '32px', md: '48px', lg: '80px' }

/** Section h2 — Figma 64px desktop → 28px mobile */
export const sectionHeadingSx = {
  ...mobileSectionTitleSx,
  lineHeight: 'normal',
  fontWeight: 400,
  color: '#111',
  [MOBILE_MQ]: { fontSize: 28 },
}

export const mobileButtonSx = {
  width: 'fit-content',
  maxWidth: '100%',
  minWidth: 'unset',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  height: 41,
  minHeight: 41,
  fontSize: 12,
  lineHeight: 'normal',
  p: '14px',
  borderRadius: '50px',
}

/** Desktop button defaults — pair with mobileButtonSx via responsiveButtonSx */
export const desktopButtonSx = {
  width: 'fit-content',
  maxWidth: '100%',
  minWidth: 'unset',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  height: 45,
  minHeight: 45,
  fontSize: 16,
  lineHeight: '17px',
  p: '14px',
  borderRadius: '50px',
}

/** Shared layout for buttons with an arrow icon */
export const buttonWithArrowSx = {
  gap: '8px',
  justifyContent: 'center',
  alignItems: 'center',
}

/** Responsive CTA sizing: 41px mobile, 45px desktop — Figma Frame 130 */
export const responsiveButtonSx = {
  width: 'fit-content',
  maxWidth: '100%',
  minWidth: 'unset',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  height: { xs: 41, sm: 45 },
  minHeight: { xs: 41, sm: 45 },
  fontSize: { xs: 12, sm: 16 },
  lineHeight: { xs: 'normal', sm: '17px' },
  p: '14px',
  borderRadius: '50px',
  [MOBILE_MQ]: {
    height: 41,
    minHeight: 41,
    fontSize: 12,
    lineHeight: 'normal',
  },
}

/** Figma icon frame — 52px outer on mobile artboard */
export const mobileIconFrameSx = {
  width: 52,
  height: 52,
  borderRadius: '10px',
  p: '10px',
  '& > div': {
    width: 32,
    height: 32,
  },
}

export const desktopIconFrameSx = {
  width: 64,
  height: 64,
  borderRadius: '10px',
  p: '10px',
  '& > div': {
    width: 38,
    height: 38,
  },
}

export const responsiveIconFrameSx = {
  width: { sm: 56, md: 60, lg: 64 },
  height: { sm: 56, md: 60, lg: 64 },
  borderRadius: '10px',
  p: '10px',
  '& > div': {
    width: { sm: 34, md: 36, lg: 38 },
    height: { sm: 34, md: 36, lg: 38 },
  },
  [MOBILE_MQ]: mobileIconFrameSx,
}

/** Card typography — Figma mobile artboard */
export const mobileCardTitleSx = {
  [MOBILE_MQ]: { fontSize: 22 },
}

export const mobileCardBodySx = {
  [MOBILE_MQ]: { fontSize: 14, lineHeight: 'normal' },
}

export const mobileFormLabelSx = {
  [MOBILE_MQ]: { fontSize: 14 },
}

export const mobileFormInputSx = {
  [MOBILE_MQ]: { fontSize: 14 },
}
